<template>
  <div class="container">
    <div class="header">
      <div class="school">您的学校</div>
      <div class="tips">超级简历保驾护航，名企Offer等你拿</div>
    </div>
    <div class="box-container flex">
      <div class="btn" v-for="(item, index) in list" :key="`btn_${item.key}`" @click="next(item)">{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      list: [
        {
          key: 'chinese',
          text: '国内院校'
        },
        {
          key: 'foreign',
          text: '海外院校'
        }
      ]
    }
  },
  methods: {
    next(obj) {
      console.log(obj);
      let { key } = obj
      this.$router.push({ path: '/questionnaire/active', query: { key } });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  background: #F9F9F9;
  position: relative;
  .header {
    width: 100vw;
    height: 236px;
    padding: 49px 24px 0 24px;
    box-sizing: border-box;
    background: url('https://files.wondercv.com/APP/wenjuan_bg.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    .school {
      font-size: 24px;
      font-weight: 600;
    }
    .tips {
      font-size: 14px;
      font-weight: 400;
      margin-top: 10px;
    }
  }
  .box-container {
    width: 327px;
    height: 226px;
    padding: 46px 26px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 10px;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    top: 135px;
    left: 24px;
    .btn {
      width: 100%;
      height: 52px;
      background: #F9F9F9;
      border-radius: 6px;
      text-align: center;
      line-height: 52px;
      font-size: 16px;
      font-weight: 500;
      color: #606060;
    }
  }
}
</style>
